var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone-icon--red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-5",
    transform: "translate(-92.000000, -6277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-icon--red",
    transform: "translate(92.000000, 6277.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#C21C27",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-icon--brown.d2dce4622ad01ee382edab80cef20a4e",
    transform: "translate(8.000000, 7.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.177231,16.9643057 C10.9562929,16.7957916 9.79569159,16.3510427 8.79290668,15.6674137 C7.63082149,14.897418 6.56332779,14.0057043 5.61049824,13.0090399 C4.44010097,11.8192307 3.2482613,10.644719 2.21545273,9.33252944 C1.40242867,8.27869842 0.675174187,7.17387557 0.278489923,5.90417916 C0.00263702626,5.09691514 -0.0695939639,4.23922267 0.0676397281,3.40048061 C0.246326334,2.39934114 0.803828543,1.58517169 1.56682035,0.903580974 C1.88150736,0.635880656 2.22327303,0.398461551 2.58712087,0.194794625 C3.02984533,-0.0727418733 3.59746117,-0.0640547938 4.03090864,0.216891082 C5.04683521,0.791971747 5.82550031,1.6802031 6.23768822,2.73418745 C6.3816176,3.03660795 6.34122688,3.38956046 6.13226312,3.65543973 C5.87674127,3.98348713 5.61049824,4.3030359 5.35318953,4.63108329 C5.12625753,4.92173669 4.89039122,5.2072909 4.68847534,5.51324184 C4.47529375,5.79914024 4.47889543,6.18285728 4.69740968,6.46508922 C5.2066665,7.1449802 5.69984154,7.84526791 6.25377002,8.49286407 C7.25603621,9.67304847 8.36581348,10.7668145 9.57019341,11.76144 C9.83822332,11.9807048 10.1259088,12.1744737 10.4118073,12.3733418 C10.6604935,12.5572377 10.9990205,12.5864517 11.2784374,12.4481299 C11.5848103,12.3044913 11.8830329,12.1456308 12.1718704,11.9722062 C12.5721284,11.7291452 12.9652389,11.4792852 13.3583495,11.2396236 C13.688767,11.0384803 14.1098595,11.0306005 14.4483378,11.2192269 C15.4621301,11.6977053 16.2885747,12.471936 16.8070009,13.4288727 C17.105403,13.9181864 17.0541686,14.5321232 16.6783465,14.9705254 C15.6902096,16.2045275 14.4268953,16.9660055 12.7472413,17 C12.5567219,16.9973635 12.3664694,16.9854498 12.177231,16.9643057 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconRed);
export default __webpack_public_path__ + "static/media/phone-icon--red.34c56a9d710d861ac0372e0a33e58c35.svg";
export { ForwardRef as ReactComponent };